import React from 'react';
import './Header.scss';


const Header = (props) => {
  return (
    <header>
      <h1>{props.title}</h1>
      <div className="menu">{props.children}</div>
    </header>
    )
}

export default Header;
